/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.DocsAndForms {
    angular.module('meevo.plugins.docsAndForms', []);
}
